import { ref } from 'vue';

const onlyHungarian = ref(false);
export const useLanguage = () => {
	return {
		onlyHungarian
	};
};
